import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "rounded-lg sm:rounded-lg px-6 py-10 bg-white w-4/6 ml-20" }
const _hoisted_2 = { class: "flex justify-center mb-4" }
const _hoisted_3 = { class: "mb-4 sm:mb-0 items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "pl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PerfilMainView = _resolveComponent("PerfilMainView")!

  return (_openBlock(), _createBlock(_component_PerfilMainView, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "items-center",
              src: _ctx.logoPilotar,
              alt: "Pilotar"
            }, null, 8, _hoisted_4)
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "text-lg font-semibold tracking-wide flex justify-center mt-5" }, "Selecione o serviço que deseja utilizar", -1)),
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in",
            appear: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  color: "custom",
                  class: "h-12 w-45 text-white mr-9 mt-5",
                  onOnPressed: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirecionarServico('dados')))
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Abertura de RENACH ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "custom",
                  class: "h-12 w-45 text-white mr-9 mt-5",
                  onOnPressed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirecionarServico('adicao-mudanca')))
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Adição e Mudança ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "custom",
                  class: "h-12 w-45 text-white mr-9 mt-5",
                  onOnPressed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirecionarServico('emissao')))
                }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" Emissão LADV ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "custom",
                  class: "h-12 w-45 text-white mr-9 mt-5",
                  onOnPressed: _cache[3] || (_cache[3] = ($event: any) => (_ctx.redirecionarServico('reexame')))
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Reexame ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  color: "custom",
                  class: "h-12 w-45 text-white mr-9 mt-5",
                  onOnPressed: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirecionarServico('consulta')))
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Consultas ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}